import { createPermission } from '@backstage/plugin-permission-common';

export const emailServiceDefinitionPermission = createPermission({
  name: 'email-service.access',
  attributes: {},
});

export const feedCreationDefinitionPermission = createPermission({
  name: 'feed-creation.access',
  attributes: {},
});

export const approvalsPermission = createPermission({
  name: 'request-access.access',
  attributes: {},
});

export const superUserPermission = createPermission({
  name: 'super-user-access.access',
  attributes: {},
});

export const stsPagePermission = createPermission({
  name: 'sts-page-access.access',
  attributes: {},
});

export const aiAgentPermission = createPermission({
  name: 'ai-agent.access',
  attributes: {},
});

export const logAnalyzerPermission = createPermission({
  name: 'log-analyzer.access',
  attributes: {},
});

// STS Permissions
export const stsProvisioningPermission = createPermission({
  name: 'sts.provisioning',
  attributes: {},
});

export const stsOperationsPermission = createPermission({
  name: 'sts.operations',
  attributes: {},
});

export const stsAdminPermission = createPermission({
  name: 'sts.admin',
  attributes: {},
});

// DX Permissions
export const dxPagePermission = createPermission({
  name: 'dx.page-access',
  attributes: {},
});

// FinOps / AI Governance Permissions
export const finopsPagePermission = createPermission({
  name: 'finops.page-access',
  attributes: {},
});

// Finance Permissions
export const financePagePermission = createPermission({
  name: 'finance.page-access',
  attributes: {},
});
